import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
	name: 'shortNumber',
	standalone: false
})
export class ShortNumberPipe implements PipeTransform {
	transform(value: number, isCurrency: boolean = false): string {
		if (!value && value !== 0) {
			return '';
		}

		const absValue = Math.abs(value);
		const sign = value < 0 ? '-' : '';

		let shortValue: number;
		let suffix: string;

		if (absValue >= 1000000000) {
			// Billions
			shortValue = absValue / 1000000000;
			suffix = 'B';
		} else if (absValue >= 1000000) {
			// Millions
			shortValue = absValue / 1000000;
			suffix = 'M';
		} else if (absValue >= 1000) {
			// Thousands
			shortValue = absValue / 1000;
			suffix = 'K';
		} else {
			// Less than 1000
			if (isCurrency) {
				return `${sign}$${Math.round(absValue).toLocaleString()}`;
			}
			return value.toString();
		}

		const showDecimal = shortValue % 10 !== 0;
		const formattedValue = showDecimal ? shortValue.toFixed(1).replace(/\.0$/, '') : Math.round(shortValue).toString();

		if (isCurrency) {
			return `${sign}$${formattedValue}${suffix}`;
		}

		return `${sign}${formattedValue}${suffix}`;
	}
}
